import SingleCategorySelector, {
  SingleCategorySelectorProps,
} from "@stadium/shared/src/components/plasmic/custom-options/category-selector/single-category-selector";

const CECategorySelector = (props: SingleCategorySelectorProps) => {
  return <SingleCategorySelector {...props} selectorSlugs={props.contextData?.categorySlugs} />;
};

export default CECategorySelector;
